import { ErrorHandler, Injectable, inject } from '@angular/core';
import { AppInsightsMonitoringService } from './app-insights-monitoring.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class AppInsightErrorHandlerService implements ErrorHandler {
  private readonly appInsightsMonitoringService = inject(AppInsightsMonitoringService);
  private readonly logger = inject(LoggerService);

  handleError(error: any): void {
    this.logger.error('An error occurred:', error);
    this.appInsightsMonitoringService.logException(error);
  }
}
